import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../store/useStore';

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onReport: (reason: string, details: string) => void;
}

export const ReportModal: React.FC<ReportModalProps> = ({ isOpen, onClose, onReport }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState<string>('');
  const [details, setDetails] = useState<string>('');
  const currentPartner = useStore((state: any) => state.currentPartner);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (reason) {
      onReport(reason, details);
      onClose();
      setReason('');
      setDetails('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 slide-in">
      <div className="bg-gray-800 rounded-lg max-w-md w-full p-6 fade-in">
        <h3 className="text-xl font-bold text-white mb-4">{t('report.title')}</h3>
        <p className="text-gray-300 mb-2">
          Reportando: <span className="font-semibold">{currentPartner?.name || 'Usuário'}</span>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-300 mb-2">{t('chat.reason')}</label>
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-yellow-400 transition-all"
              required
            >
              <option value="">{t('report.details')}</option>
              <option value="inappropriate_content">{t('report.inappropriate')}</option>
              <option value="harassment">{t('report.harassment')}</option>
              <option value="spam">{t('report.spam')}</option>
              <option value="other">{t('report.other')}</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-300 mb-2">{t('report.details')}</label>
            <textarea
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-yellow-400 transition-all"
              rows={3}
              placeholder={t('chat.placeholder')}
            />
          </div>

          <div className="flex space-x-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 px-4 bg-gray-600 text-white rounded hover:bg-gray-500 transition-colors transition-all"
            >
              {t('report.cancel')}
            </button>
            <button
              type="submit"
              className="flex-1 py-2 px-4 bg-red-600 text-white rounded hover:bg-red-500 transition-colors transition-all"
            >
              {t('report.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
